import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import LandingPage from "./pages/LandingPage";
import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";
import CookieBanner from "./components/CookieBanner";
import { CookieConsentProvider } from "./context/CookieConsentContext";
import "./App.css";

function App() {
  return (
    <CookieConsentProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
        </Routes>
        <CookieBanner />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </CookieConsentProvider>
  );
}

export default App;
